//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricAnalysis.js";
import "../no/Builder.js";
import "../no/SelectIBaseCurve.js";
import "../no/SelectIParameterizedSurface.js";
import "../no/SelectObject.js";
let d=[[[0,"AngleTolerance",1,0],[1,"Curve",0,"SelectIBaseCurve",0],[0,"DeviationOption",1,0],[0,"DistanceTolerance",1,0],[1,"FaceOfFirstEdge",0,"SelectIParameterizedSurface",0],[1,"FaceOfSecondEdge",0,"SelectIParameterizedSurface",0],[1,"FirstCurve",0,"SelectIBaseCurve",0],[1,"FirstEdge",0,"SelectIBaseCurve",0],[1,"FirstFace",0,"SelectIParameterizedSurface",0],[0,"NumberCheckPoints",1,0],[0,"NumberUcheckPoints",1,0],[0,"NumberVcheckPoints",1,0],[1,"SecondCurve",0,"SelectIBaseCurve",0],[1,"SecondEdge",0,"SelectIBaseCurve",0],[1,"SecondFace",0,"SelectIParameterizedSurface",0],[0,"Type",1,0]],[[[],"Check",{},0,0]],[]];
SPLM.GeometricAnalysis.DeviationChecking = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricAnalysis.DeviationChecking";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricAnalysis.DeviationChecking.DeviationOptions = Object.freeze({
    "NoDeviations" : "NoDeviations", "AllDeviations" : "AllDeviations", "MaximumDistance" : "MaximumDistance", "MinimumDistance" : "MinimumDistance", "MaximumAngle" : "MaximumAngle", "MinimumAngle" : "MinimumAngle"});

SPLM.GeometricAnalysis.DeviationChecking.Types = Object.freeze({
    "CurveToCurve" : "CurveToCurve", "CurveToFace" : "CurveToFace", "EdgeToFace" : "EdgeToFace", "FaceToFace" : "FaceToFace", "EdgeToEdge" : "EdgeToEdge"});

export default SPLM;